import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import { handleStateChangeFromProps } from './helpers';
export default class SelectInput extends React.Component {
    state = {
        error: undefined,
        value: '',
        enabled: '',
        onChange: null,
        type: 'text',
        name: '',
        title: '',
        width: 12,
        data: '',
        renderedData: null,
        variant: 'standard',
        disabled: false,
        hidden: false,
        required: false,
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    componentDidMount() {
        let reneredItems = [];
        let data = this.state.data;
        if (typeof (data) === 'string') {
            DataApi.getSelect(data).then((res) => {
                for (let item in res.data)
                    reneredItems.push(<MenuItem key={item} value={res.data[item].id}>{res.data[item].name}</MenuItem>)
                this.setState({ renderedData: reneredItems })
            });

        } else {
            for (let item in data)
                reneredItems.push(<MenuItem key={data[item].id} value={data[item].id}>{data[item].name}</MenuItem>)
            this.setState({ renderedData: reneredItems })
        }

    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        if (!Array.isArray(prevState.data) && Array.isArray(nextProps.data)
            || (Array.isArray(nextProps.data) && JSON.stringify(nextProps.data) !== JSON.stringify(prevState.data))) {
            let reneredItems = [];
            for (let item in nextProps.data)
                reneredItems.push(<MenuItem key={nextProps.data[item].id} value={nextProps.data[item].id}>{nextProps.data[item].name}</MenuItem>)
            prevState.renderedData = reneredItems;
        }

        return handleStateChangeFromProps(nextProps, prevState)
    }

    render() {
        const { error, value, enabled, onChange, name, title, width, renderedData, variant,
            disabled, hidden, required } = this.state;

        if (hidden) {
            if (typeof (hidden) !== 'function' || hidden())
                return <div />
        }
        return (
            <Grid item xs={12} sm={width ? width : 12} data-form-element={name}>
                <FormControl margin={this.props.margin || "normal"} fullWidth error={error && enabled} variant={variant} >
                    <InputLabel htmlFor={name}>{title}  {required ? '*' : ''}</InputLabel>
                    <Select id={name} name={name} value={value || ''} onChange={onChange} disabled={disabled}>
                        <MenuItem value={null}>
                            <em>None</em>
                        </MenuItem>
                        {renderedData}
                    </Select>
                    {error && enabled ? <FormHelperText>{typeof (error) === 'string' ? error : 'this field is required'}</FormHelperText> : ''}
                </FormControl>
            </Grid>
        );
    }
}